<template>
  <div class="listTopImg">
    <div v-if="this.$store.state.webNavigator=='pc'" class="tltTop-img-bar marginAuto positionRE">
      <img class="tltTop-img"
           :src="imgType=='1'?
         src0:
         imgType=='2'?
         src1:
         imgType=='3'?
         src2:
         imgType=='4'?
         src3:
         imgType=='5'?
         src4:''"
           alt="" title="">
      <div class="content-Top">
        <p class="font36px content-Top-tlt colffffff">
          {{imgType=='2'?'“体质管理+营养管理+作息管理”健康瘦身方案':imgType=='3'?'“体质管理+营养管理+作息管理”健康瘦身方案':imgType=='1'?'脂玫乐专业健康瘦身品牌':imgType=='4'?'脂玫乐 专业健康瘦身品牌':imgType=='5'?'健康瘦身，发现更好的自己':''}}</p>
        <p class="font26px content-Top-p colffffff">{{imgType=='2'?'':imgType=='3'?'':imgType=='1'?'健康瘦身，发现更好的自己':imgType=='4'?'健康瘦身，发现更好的自己':imgType=='5'?'健康瘦身，发现更好的自己':''}}</p>
      </div>
    </div>
    <div v-if="this.$store.state.webNavigator=='phone'" :class="imgType!='5'?'phone-imgBar':'phone-imgBar2'">
      <img :class="imgType!='5'?'phone-img':'phone-img2'"
           :src="imgType=='1'?
         phone1:
         imgType=='2'?
         phone2:
         imgType=='3'?
         phone3:
         imgType=='4'?
         phone4:
         imgType=='5'?
         phone5:''"
           alt="" title="">
    </div>
  </div>
</template>

<script>
import { myFun } from "../../plug/modifyImagePath"
export default {
  name: 'listTopImg',
  props: {
    imgType: {
      type: String,
      default: '1',
    },
  },
  data(){
    return{
      src0:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/topImg/topImg1.png'),
      src1:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/topImg/topImg2.png'),
      src2:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/topImg/topImg3.png'),
      src3:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/topImg/topImg4.png'),
      src4:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/topImg/topImg5.png'),
      phone1:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/topImg/topImg1.png'),
      phone2:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/topImg/topImg2.png'),
      phone3:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/topImg/topImg3.png'),
      phone4:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/topImg/topImg4.png'),
      phone5:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/topImg/topImg5.png')
    }
  }
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url('listTopImgPhone');
  }

  @media screen and (min-width: 800px) {
    @import url('listTopImg');
  }

</style>



// WEBPACK FOOTER //
// listTopImg.vue